import BemIt, { addClass } from "@gtechdoodler/bem-it";
import List from "../../data/List";
import TextField from "../TextField";
import WithInputOptions from "../hocs/WithInputOptions";
import { PredictiveTextFieldProps } from "./PredictiveTextField.types";

const PredictiveTextField: React.FC<PredictiveTextFieldProps> = ({
	className,
	children,
	colorOn,
	showOptions,
	onBlur,
	onSelectItem,
	...props
}) => {
	const block = new BemIt("PredictiveTextField");

	return (
		<WithInputOptions
			className={addClass(className).after(block)}
			backgroundColor={colorOn}
			onBlur={onBlur}
			showOptions={showOptions}
			renderInput={() => (
				<TextField
					disableUpDownArrowKeys
					colorOn={colorOn}
					onBlur={onBlur}
					{...props}
				/>
			)}
		>
			<List direction="column" onSelectItem={onSelectItem} colorOn={colorOn}>
				{children}
			</List>
		</WithInputOptions>
	);
};

export default PredictiveTextField;
